function identity(i) {
  return i;
}
export function keyBy(collection, keyMapper, valueMapper = identity) {
  return collection.reduce((map, item, index) => {
    const key = keyMapper(item, index);
    map[key] = valueMapper(item, index, map[key]);
    return map;
  }, {});
}